import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from 'AppSrc/core/app';
import * as serviceWorker from './serviceWorker'; // See service worker note.

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// ** This must be disabled in order for the Cloudfront API-Gateway/S3 routing
//    to work correctly.
// Adding a comment to test the build and deployment
serviceWorker.unregister();
